import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Replace with actual API URL

const InvoicePrint = () => {
  const [invoiceList, setInvoiceList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryList, setCategoryList] = useState([]);
  const recordsPerPage = 10;

  useEffect(() => {
    const token = localStorage.getItem("jwt_token");
    const fetchInvoices = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}api/getDoctorApproval`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();
        if (Array.isArray(data.data)) {
          setInvoiceList(data.data);
        } else {
          console.error("Data is not an array:", data);
          setInvoiceList([]);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };
    fetchInvoices();
  }, []);

  // Filtering Logic
  const filteredData = invoiceList.filter(item =>
    item.inv_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.doct_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.paymode.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

  // Change Page
  const goToPage = (pageNumber) => setCurrentPage(pageNumber);

  // Sample Table Data (Replace with API Data)
  const tableData = [
    ["S.No.", "Test Particulars", "Actual Nos. per Month", "Prof. Fee Per Case", "Prof. Fee Amount"],
    ["1", "MRI (Brain & Spine)", "300", "-", "-"],
    ["2", "MRI (Cardiac)", "-", "-", "-"],
    ["3", "MRI (Others)", "450", "-", "-"],
    ["4", "MRI - Boss Protocol", "750", "-", "-"],
    ["5", "MRI Screening", "150", "-", "-"],
    ["6", "CT (Brain & PNS)", "250", "-", "-"],
    ["7", "CT (Others)", "-", "-", "-"],
    ["8", "CT (Coronary)", "-", "-", "-"],
    ["9", "CT (Angios)", "600", "-", "-"],
    ["10", "CT Screening", "-", "-", "-"],
    ["11", "Contrast Studies", "0", "-", "-"],
    ["", "Grand Total", "", "", ""],
  ];

  const finalPayDetails = [
    ["Final Pay Calculation Details", "Amount"],
    ["Professional Fee Payable", "-"],
    ["Less: any other Deductions", "-"],
    ["Add: any other Additions", "-"],
    ["Total Professional Fee Payable", "-"],
    ["Less: TDS @10%", "-"],
    ["Amount Credited to your Bank Account", "-"],
  ];


  const token = localStorage.getItem("jwt_token");

  const fetchCategoriesList = async (inv_no) => {
    const token = localStorage.getItem("jwt_token");
    try {
      const response = await fetch(`${API_BASE_URL}api/getCategoriesListDistinct?inv_no=${inv_no}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch categories list!");
      }

      const data = await response.json();
      return data.data || []; // Ensure an array is returned
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };





  const fetchInvoiceDetails = async (inv_no) => {
    const token = localStorage.getItem("jwt_token");
    try {
      const response = await fetch(`${API_BASE_URL}api/inv_details?inv_no=${inv_no}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch invoice details");

      const data = await response.json();
      return data.data; // Assuming the API returns an object with data
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      return null;
    }
  };

  const fetchInvoiceDetails1 = async (inv_no) => {
    const token = localStorage.getItem("jwt_token");
    try {
      const response = await fetch(`${API_BASE_URL}api/inv_details_view?inv_no=${inv_no}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch invoice details");

      const data = await response.json();
      console.log("Fetched Invoice Details 1:", data); // Debugging
      return data.data || { items: [] }; // Ensure items exists
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      return { items: [] }; // Return an empty array on error
    }
  };

  const getTestCategoryById = (categoryId, categoryListArray) => {
    const category = categoryListArray.find(cat => cat.main_category === categoryId);
    return category ? category.test_category : "Unknown Category";
  };


  // Function to Generate PDF
  const generatePDF = async (inv_no) => {
    const invoiceDataArray = await fetchInvoiceDetails(inv_no); // Fetch invoice details
    const invoiceData1Array = await fetchInvoiceDetails1(inv_no); // Fetch invoice test details

    if (!invoiceDataArray || invoiceDataArray.length === 0) {
      return alert("Failed to fetch invoice details!");
    }

    const invoiceData = invoiceDataArray[0]; // Get the first item (object)

    if (!invoiceData1Array || invoiceData1Array.length === 0) {
      return alert("Failed to fetch invoice test details!");
    }

    // No need for invoiceData1[0], as invoiceData1Array is already the array of test items
    const items = invoiceData1Array; // Use the fetched array directly

    const doc = new jsPDF("p", "mm", "a4");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(`Professional Fee Calculations for Month of ${invoiceData.invoice_month} ${invoiceData.invoice_year}`, 10, 20);

    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.text(`Consultant Name: ${invoiceData.comp_name}`, 10, 30);
    doc.text(`BM ID No: ${invoiceData.doct_code}`, 10, 38);
    doc.text(`Duration: ${invoiceData.inv_from} - ${invoiceData.inv_to}`, 10, 46);

    // Convert API data into table format
    const tableData = items.map((item, index) => [
      index + 1, item.test_name, item.doct_amount, item.test_code || "-",
    ]);

    doc.autoTable({
      startY: 55,
      head: [["S.No.", "Test Particulars", "Amount", "Test Code"]],
      body: tableData,
      theme: "plain",
      styles: { fontSize: 10, cellPadding: 2 },
    });

    doc.text("This is a system-generated document.", 10, doc.internal.pageSize.height - 10);
    doc.save(`Invoice_${inv_no}.pdf`);
  };



  const generateExcel = async (inv_no) => {
    const invoiceDataArray = await fetchInvoiceDetails(inv_no);
    const invoiceData1Array = await fetchInvoiceDetails1(inv_no);
    const categoryListArray = await fetchCategoriesList(inv_no);

    if (!invoiceDataArray || invoiceDataArray.length === 0) {
      return alert("Failed to fetch invoice details!");
    }

    const invoiceData = invoiceDataArray[0];

    if (!invoiceData1Array || invoiceData1Array.length === 0) {
      return alert("Failed to fetch invoice test details!");
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Invoice Details");

    // Yellow background fill style
    const yellowFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFF00" }, // Yellow
    };

    // Border style
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Center alignment style
    const centerAlignment = { horizontal: "center" };

    // Add an empty row at A1
    worksheet.addRow(["", ""]); // A1 (Column A) is now empty

    // Add Invoice No (Starts at B2)
    const row2 = worksheet.addRow(["", "", `Invoice No: ${inv_no}`]); // Column A is empty
    const cellC2 = worksheet.getCell("C2");
    cellC2.fill = yellowFill;
    cellC2.border = borderStyle;
    cellC2.alignment = centerAlignment;

    // Add Consultant Name (Starts at B3)
    const row3 = worksheet.addRow(["", "", invoiceData.comp_name]); // Column A is empty
    const cellC3 = worksheet.getCell("C3");
    cellC3.fill = yellowFill;
    cellC3.border = borderStyle;
    cellC3.alignment = centerAlignment;

    worksheet.addRow(["", ""]); // Empty row for spacing

    // Add table headers (Shifted to Column B with Borders & Centered)
    const headerRow = worksheet.addRow(["", "S.No.", "Name of the Investigation", "Actuals", "Reporting Charges (Rs)", "Incentive Amount"]);
    headerRow.font = { bold: true };

    // Apply border & center alignment to header row
    headerRow.eachCell((cell, colNumber) => {
      if (colNumber > 1) {
        cell.border = borderStyle; // Ignore Column A
        cell.alignment = centerAlignment; // Center align
      }
    });

    let totalActuals = 0;
    let totalIncentive = 0;

    // Add items (Shifted to Column B with Borders & Centered)
    categoryListArray.forEach((item, index) => {
      const actuals = item.cnt || 0;
      const incentive = item.cnt * item.amt || 0;

      totalActuals += parseFloat(actuals); // Ensure actuals is treated as a number
      totalIncentive += parseFloat(incentive);

      const dataRow = worksheet.addRow([
        "",
        index + 1,
        item.test_category,
        actuals,
        item.amt,
        incentive
      ]);

      // Apply border & center alignment to each cell in the data row
      dataRow.eachCell((cell, colNumber) => {
        if (colNumber > 1) {
          cell.border = borderStyle; // Ignore Column A
          cell.alignment = centerAlignment; // Center align
        }
      });
    });

    // Add an empty row before Grand Total
    // worksheet.addRow(["", ""]);

    // Add Grand Total row
    const totalRow = worksheet.addRow([
      "",
      "",
      "Grand Total",

      totalActuals,
      "",
      totalIncentive
    ]);

    totalRow.font = { bold: true };

    totalRow.eachCell((cell, colNumber) => {
      if (colNumber > 1) {
        cell.border = borderStyle;
        cell.alignment = centerAlignment;
      }
    });

    // Add Net Amount Payable row
    const netAmountRow = worksheet.addRow([
      "",
      "",
      `Net Amount Payable for ${invoiceData.invoice_month} ${invoiceData.invoice_year}`,
      "",
      "",
      totalIncentive
    ]);

    // Add Less: TDS @10% row
    const tdsAmount = (totalIncentive * 0.1).toFixed(2);
    const tdsRow = worksheet.addRow(["", "", `Less : TDS @10%`, "", "", tdsAmount]);

    // Add Amount Credited row
    const creditedAmount = (totalIncentive - tdsAmount).toFixed(2);
    const creditedRow = worksheet.addRow(["", "", `Amount Credited to your Bank Account`, "", "", creditedAmount]);

    // Apply bold font, borders, and center alignment to the three rows
    [netAmountRow, tdsRow, creditedRow].forEach(row => {
      row.font = { bold: true };
      row.eachCell((cell, colNumber) => {
        if (colNumber > 1) { // Ignore Column A
          cell.border = borderStyle;
          cell.alignment = centerAlignment;
        }
      });
    });
    worksheet.columns.forEach((column, index) => {
      if (index === 2) {  // Column C (3rd column) - "Name of the Investigation"
        column.width = 40; // Set wider width for better content visibility
      } else {
        column.width = 15; // Default width for other columns
      }
    });
    // Write the file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Invoice_${inv_no}.xlsx`);
  };

  const generateExcel1 = async (inv_no) => {
    const invoiceDataArray = await fetchInvoiceDetails(inv_no);
    const invoiceData1Array = await fetchInvoiceDetails1(inv_no);
    const categoryListArray = await fetchCategoriesList(inv_no);

    if (!invoiceDataArray || invoiceDataArray.length === 0) {
      return alert("Failed to fetch invoice details!");
    }

    const invoiceData = invoiceDataArray[0];

    if (!invoiceData1Array || invoiceData1Array.length === 0) {
      return alert("Failed to fetch invoice test details!");
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Invoice Details");

    // Yellow background fill style
    const yellowFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFF00" }, // Yellow
    };

    // Border style
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    const boldFont = { bold: true };
    // Center alignment style
    const centerAlignment = { horizontal: "center" };

    // Add an empty row at A1
    worksheet.addRow(["", ""]); // A1 (Column A) is now empty

    const getDaysInMonth = (dateString) => {
      const date = new Date(dateString); // Convert string to Date object
      const year = date.getFullYear(); // Extract year
      const month = date.getMonth() + 1; // Extract month (0-based, so add 1)
      
      return new Date(year, month, 0).getDate(); // Get last date of the month
  };
  
  
  const daysInMonth = getDaysInMonth(invoiceData.inv_from);
  const lopDays = invoiceData.lop_days || 0; // Ensure LOP days are treated as a number
const netPayableDays = daysInMonth - lopDays;
    const incentiveHeader = worksheet.addRow(["", "", `Incentive Calculation for ${invoiceData.invoice_month} ${invoiceData.invoice_year}`]);
    incentiveHeader.font = boldFont; // Keep it bold
    incentiveHeader.eachCell((cell, colNumber) => {
        if (colNumber > 1) {
            cell.alignment = centerAlignment;
        }
    });

    // Add Invoice No (Starts at B2)
    const row2 = worksheet.addRow(["", "", `Bm Id: ${invoiceData.doct_code}`]); // Column A is empty
    const cellC2 = worksheet.getCell("C2");

    const row3 = worksheet.addRow(["", "", invoiceData.comp_name]); // Column A is empty
    const cellC3 = worksheet.getCell("C3");
    // cellC2.fill = yellowFill;
    // cellC2.border = borderStyle;
    // cellC2.alignment = centerAlignment;

    // Add Consultant Name (Starts at B3)
    const row4 = worksheet.addRow(["", "",`Total Working Days: ${daysInMonth}`]); // Column A is empty
    const cellC4 = worksheet.getCell("C4");

    const row5 = worksheet.addRow(["", "",`LOP Days: ${invoiceData.lop_days}`]); // Column A is empty
    const cellC5 = worksheet.getCell("C5");

    const row6 = worksheet.addRow(["", "",`Total Deviation Minutes: ${invoiceData.time_deviation_minutes}`]); // Column A is empty
    const cellC6 = worksheet.getCell("C6");

    const row7 = worksheet.addRow(["", "",`Time Devication Days: 30`]); // Column A is empty
    const cellC7 = worksheet.getCell("C7");

    const row8 = worksheet.addRow(["", "",`Net Payable Days: ${netPayableDays}`]); // Column A is empty
    const cellC8 = worksheet.getCell("C8");
    // cellC3.fill = yellowFill;
    // cellC3.border = borderStyle;
    // cellC3.alignment = centerAlignment;

    

    worksheet.addRow(["", ""]); // Empty row for spacing

    // Add table headers (Shifted to Column B with Borders & Centered)
    const headerRow = worksheet.addRow(["", "S.No.", "Name of the Investigation", "Actuals", "Reporting Charges (Rs)", "Incentive Amount"]);
    headerRow.font = { bold: true };

    // Apply border & center alignment to header row
    headerRow.eachCell((cell, colNumber) => {
      if (colNumber > 1) {
        cell.border = borderStyle; // Ignore Column A
        cell.alignment = centerAlignment; // Center align
      }
    });

    let totalActuals = 0;
    let totalIncentive = 0;

    // Add items (Shifted to Column B with Borders & Centered)
    categoryListArray.forEach((item, index) => {
      const actuals = item.cnt || 0;
      const incentive = item.cnt * item.amt || 0;

      totalActuals += parseFloat(actuals); // Ensure actuals is treated as a number
      totalIncentive += parseFloat(incentive);

      const dataRow = worksheet.addRow([
        "",
        index + 1,
        item.test_category,
        actuals,
        item.amt,
        incentive
      ]);

      // Apply border & center alignment to each cell in the data row
      dataRow.eachCell((cell, colNumber) => {
        if (colNumber > 1) {
          cell.border = borderStyle; // Ignore Column A
          cell.alignment = centerAlignment; // Center align
        }
      });
    });

    // Add an empty row before Grand Total
    // worksheet.addRow(["", ""]);

    // Add Grand Total row
    const totalRow = worksheet.addRow([
      "",
      "",
      "Grand Total",

      totalActuals,
      "",
      totalIncentive
    ]);

    totalRow.font = { bold: true };

    totalRow.eachCell((cell, colNumber) => {
      if (colNumber > 1) {
        cell.border = borderStyle;
        cell.alignment = centerAlignment;
      }
    });

    // Add Net Amount Payable row
    const netAmountRow = worksheet.addRow([
      "",
      "",
      `Net Amount Payable for ${invoiceData.invoice_month} ${invoiceData.invoice_year}`,
      "",
      "",
      totalIncentive
    ]);

    const perDayAmount = totalIncentive / daysInMonth; // Amount per working day
const lopDeduction = (perDayAmount * lopDays).toFixed(2);

const lopDeductionRow = worksheet.addRow([
  "",
  "",
  `Less for LOP Days (${lopDays} day${lopDays > 1 ? "s" : ""})`,
  "",
  "",
  lopDeduction
]);


const totalEarnedConsideration = (totalIncentive - lopDeduction).toFixed(2);

const earnedConsiderationRow = worksheet.addRow([
  "",
  "",
  "Total Earned Consideration",
  "",
  "",
  totalEarnedConsideration
]);

    // Add Less: TDS @10% row
    const tdsAmount = (totalEarnedConsideration * 0.1).toFixed(2);
    const tdsRow = worksheet.addRow(["", "", `Less : TDS @10%`, "", "", tdsAmount]);

    // Add Amount Credited row
    const creditedAmount = (totalEarnedConsideration - tdsAmount).toFixed(2);
    const creditedRow = worksheet.addRow(["", "", `Amount Credited to your Bank Account`, "", "", creditedAmount]);

    // Apply bold font, borders, and center alignment to the three rows
    [lopDeductionRow,netAmountRow, tdsRow, creditedRow].forEach(row => {
      row.font = { bold: true };
      row.eachCell((cell, colNumber) => {
        if (colNumber > 1) { // Ignore Column A
          cell.border = borderStyle;
          cell.alignment = centerAlignment;
        }
      });
    });
    worksheet.columns.forEach((column, index) => {
      if (index === 2) {  // Column C (3rd column) - "Name of the Investigation"
        column.width = 40; // Set wider width for better content visibility
      } else {
        column.width = 15; // Default width for other columns
      }
    });
    // Write the file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Invoice_${inv_no}.xlsx`);
  };








  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <Navbar />
        <div className="content-inner container-fluid">
          <h4 className="mb-3">Doctor Invoice Approval</h4>

          <input
            type="text"
            className="form-control w-25 mb-3"
            placeholder="Search by Invoice No, Doctor Code, Pay Mode"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />



          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Invoice No</th>
                  <th>Invoice Date</th>
                  <th>Doctor Code</th>
                  <th>Doctor Name</th>
                  <th>Processed Amount</th>
                  <th>Payment Mode</th>
                  <th>No. of Cases</th>
                  <th>Print</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length > 0 ? (
                  currentRecords.map((invoice, index) => (
                    <tr key={invoice.inv_no}>
                      <td>{indexOfFirstRecord + index + 1}</td>
                      <td>{invoice.inv_no}</td>
                      <td>{invoice.inv_date}</td>
                      <td>{invoice.doct_code}</td>
                      <td>{invoice.comp_name}</td>
                      <td>{invoice.process_amt}</td>
                      <td>{invoice.paymode}</td>
                      <td>{invoice.no_of_cases}</td>
                      <td>
                        <button className="btn btn-primary m-2" onClick={() => generatePDF(invoice.inv_no)}>
                          <i className="bi bi-file-earmark-pdf me-2"></i>
                        </button>

                        {invoice.paymode != 'Target' && (<button className="btn btn-success m-2" onClick={() => generateExcel(invoice.inv_no)}>
                          <i className="bi bi-file-earmark-excel me-2"></i>
                        </button>)}
                        {invoice.paymode === 'Target' && (<button className="btn btn-success m-2" onClick={() => generateExcel1(invoice.inv_no)}>
                          <i className="bi bi-file-earmark-excel me-2"></i>
                        </button>)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="7" className="text-center">No records found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default InvoicePrint;
